import { Mapper } from '@Features/utils/prepareSearchCriterias';
import { SearchItemOperator } from '@Types/api/common/filters';
import { CountryDict, TypeDict } from '@Types/index';

import { FilterForm } from './types';

export const initialValuesFilterForm: FilterForm = {
  travelDate: '',
  returnDate: '',
  statuses: [],
  placeOfTravel: '',
  totDays: '',
  purposeOfTravel: '',
  approvedTravelAmount: null,
  country: [],
  sponsoredBy: '',
  companyName: [],
  subContractorName: '',
  supplierName: '',
};

export const filterTypes: Record<
  keyof typeof initialValuesFilterForm,
  SearchItemOperator
> = {
  travelDate: 'ge',
  returnDate: 'le',
  statuses: 'in',
  placeOfTravel: 'like',
  totDays: 'eq',
  purposeOfTravel: 'like',
  approvedTravelAmount: 'eq',
  country: 'in',
  sponsoredBy: 'eq',
  companyName: 'in',
  subContractorName: 'like',
  supplierName: 'like',
};

export const getFiltersMapper =
  (statuses: TypeDict[], countries: CountryDict[]): Mapper =>
  (key, value) => {
    if (key === 'travelDate') {
      return ['travelDate', value];
    }

    if (key === 'returnDate') {
      return ['returnDate', value];
    }

    if (key === 'placeOfTravel') {
      return ['destination', value];
    }

    if (key === 'totDays') {
      return ['totDays', Number(value)];
    }

    if (key === 'purposeOfTravel') {
      return ['remarks', value];
    }

    if (key === 'approvedTravelAmount') {
      return ['eligibleDays', Number(value)];
    }

    if (key === 'country') {
      const countryCodes = (value as string[]).map(
        (item) => countries.find((country) => country.countryName === item)!.id
      );
      return ['leaveTypeID', countryCodes];
    }

    if (key === 'sponsoredBy') {
      return ['ticketRequired', Number(value)];
    }

    if (
      key === 'subContractorName' ||
      key === 'supplierName' ||
      key === 'companyName'
    ) {
      return ['batchNo', value];
    }

    const statusResultValue = (value as string[]).map(
      (item) => statuses.find((status) => status.codeDesc === item)!.codeNum
    );
    return ['reqStatusId', statusResultValue];
  };
